// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__fqtlY","checkboxInput--secondary":"Checkbox_checkboxInput--secondary__JuRwY","checkboxInputChecked":"Checkbox_checkboxInputChecked__S+5IH"};